
export class CandidatoCursoEspecializado {
  idCandidato: string;
  idCursoEspecializado: string;
  codigoTurmaSigop: number;
  statusAluno: string;
  statusTurma: string;
  idStatusTurma: number;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/candidatoCursoEspecializado.ts